import * as moment from 'moment';

export const DateRangePickerOptions = {
  
  settings: {
    locale: {
      format: 'DD/MM/YY HH:mm:ss',
      applyLabel: 'Áp dụng',
      cancelLabel: 'Hủy',
      fromLabel: 'Từ',
      toLabel: 'Tới',
      customRangeLabel: 'Tùy chọn',
      daysOfWeek: ['CN', 'Hai', 'Ba', 'Tư', 'Năm', 'Sáu', 'Bảy'],
      monthNames: ['Tháng 1 -', 'Tháng 2 -', 'Tháng 3 -', 'Tháng 4 -', 'Tháng 5 -', 'Tháng 6 -',
        'Tháng 7 -', 'Tháng 8 -', 'Tháng 9 -', 'Tháng 10 -', 'Tháng 11 -', 'Tháng 12 -']
    },
    timePicker: true,
    datePicker: true,
    alwaysShowCalendars: false,
    ranges: {
      // 'Toàn thời gian': [moment('20170429').startOf('day'), moment().endOf('day')],
      '24 giờ': [moment().subtract(1, 'day'), moment()],
      'Hôm nay': [moment().startOf('day'), moment().endOf('day')],
      'Hôm qua': [moment().subtract(1, 'day').startOf('day'), moment().subtract(1, 'day').endOf('day')],
      'Tuần này': [moment().startOf('isoWeek'), moment().endOf('isoWeek')],
      'Tuần trước': [moment().subtract(1, 'week').startOf('isoWeek'), moment().subtract(1, 'week').endOf('isoWeek')],
      'Tháng này': [moment().startOf('month'), moment().endOf('month')],
      'Tháng trước': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
    },
    opens: 'left',
    maxDate: moment().endOf('day').toDate(),
    timePicker24Hour: true,
    timePickerSeconds: true
  },
  dateInput: {
    start: moment().subtract(1, 'day'),
    end: moment()
  },
  options: {
    locale: {
      format: 'DD/MM/YY HH:mm:ss'
    },
    alwaysShowCalendars: false,
    timePickerSeconds: true,
    pick12HourFormat: false
  },
  settingReportFilter: {
    locale: { format: 'DD/MM/YYYY HH:mm:ss' },
    timePicker: true,
    timePicker24Hour: true,
    timePickerSeconds: true,
    alwaysShowCalendars: false,
    maxDate: moment().endOf('day').toDate()
  }
};



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/_helpers/date-range-picker-options.ts